/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUsersByRoleQueryResult } from '../../models/get-users-by-role-query-result';

export interface ApiCommonDashboardGetUsersPost$Params {
  Role?: string;
  StackholderId?: number;
}

export function apiCommonDashboardGetUsersPost(http: HttpClient, rootUrl: string, params?: ApiCommonDashboardGetUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByRoleQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiCommonDashboardGetUsersPost.PATH, 'post');
  if (params) {
    rb.query('Role', params.Role, {});
    rb.query('StackholderId', params.StackholderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUsersByRoleQueryResult>;
    })
  );
}

apiCommonDashboardGetUsersPost.PATH = '/api/Common/Dashboard/GetUsers';
